var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map_info"},[_c('div',{staticClass:"map_info_icon"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"map_info_text"},[_c('span',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.description)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }